module.exports = __webpack_public_path__ + "assets/e902206cf94b318156c51b9175997a92.png";